module.exports = __webpack_public_path__ + "static/pic6-f23f1a80e79b44e1ee999b096be30b03.jpg";